// extracted by mini-css-extract-plugin
export default {"introRoot":"intro_introRoot__+r8yI"};